module.exports = __webpack_public_path__ + "img/hospital.e31c4ea3.svg";